module.exports = __webpack_public_path__ + "media/halbschriftliche-Subtraktion-Video.e9f5d347.mp4";